export const formatDate = (date) => {
    const d = new Date(date);
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'America/Bogota'
    };
    // toLocaleString returns "DD/MM/AAAA HH:MM"
    const newDate = d.toLocaleString('es-ES', options).replace(',', '');
    return newDate;
}